import React, { Component } from 'react';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import PropTypes from 'prop-types';

export default class ConfirmDialog extends Component {
  static propTypes = {
    title: PropTypes.string.isRequired,
    message: PropTypes.string.isRequired,
    onClick: PropTypes.func.isRequired,
    onClose: PropTypes.func.isRequired,
  };

  static defaultProps = {
    open: true,
  };
  constructor(props) {
    super(props);
    this.state = {
      modal: this.props.open,
    };
  }

  toggle = () => {
    this.setState({
      modal: !this.state.modal,
    });
    this.props.onClose();
  };

  handleConfirmButton = () => {
    this.toggle();
    this.props.onClick();
  };
  render() {
    return (
      <div>
        <Modal isOpen={this.state.modal} toggle={this.toggle}>
          <ModalHeader toggle={this.toggle}>{this.props.title}</ModalHeader>
          <ModalBody>{this.props.message}</ModalBody>
          <ModalFooter>
            <Button color="primary" onClick={() => this.handleConfirmButton()}>
              Confirm
            </Button>{' '}
            <Button color="secondary" onClick={this.toggle}>
              Cancel
            </Button>
          </ModalFooter>
        </Modal>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/views/Components/ConfirmDialog.js